import { Button, Card, Chip, Typography } from "@mui/material";
import { Timeline, AttachFile, Visibility } from "@mui/icons-material";
import { formatDisplayDateTime } from "utils/dateFormat";
import { useEffect, useState } from "react";
import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { API_URL } from "const/constants";

const TimelineTab = ({ data, setTimelineDialogOpen }) => {
  const [timelineEvents, setTimelineEvents] = useState([]);
  const { mutate: getTimelineEvents } = useMutation({
    mutationFn: async () => {
      const response = await axios.get(`${API_URL}/rpl/student-rpl/${data?.id}/change-history`);
      return response.data?.data;
    },
    onSuccess: (data) => {
      console.log(data);
      setTimelineEvents(data || []);
    },
    onError: (error) => {
      console.log(error);
    },
  });

  useEffect(() => {
    if (data?.id) {
      getTimelineEvents();
    }
  }, [data?.id]);

  const sortedEvents = [...timelineEvents].sort(
    (a, b) => new Date(b?.changeDate) - new Date(a?.changeDate)
  );

  return (
    <div className="space-y-4 my-4">
      <div className="flex justify-between items-center">
        <Typography variant="h6" className="font-semibold">
          Activity Timeline
        </Typography>
        {/* {data?.id && (
          <Button
            variant="contained"
            startIcon={<Timeline />}
            onClick={() => setTimelineDialogOpen(true)}
            size="small"
          >
            Add Event
          </Button>
        )} */}
      </div>

      {sortedEvents.length === 0 ? (
        <Card className="p-6 text-center">
          <Typography variant="body2" className="text-app-text-secondary">
            No timeline events yet.{" "}
            {data?.id ? "Add an event to get started." : "Save the RPL certificate to add events."}
          </Typography>
        </Card>
      ) : (
        <div className="flow-root">
          <ul className="-mb-8">
            {sortedEvents.map((event, idx) => (
              <li key={event.id || idx}>
                <div className="relative pb-8">
                  {idx !== sortedEvents.length - 1 && (
                    <span
                      className="absolute top-4 left-4 -ml-px h-full w-0.5 bg-app-surface-hover"
                      aria-hidden="true"
                    />
                  )}
                  <div className="relative flex space-x-3">
                    <div>
                      <span
                        className={`h-8 w-8 rounded-full flex items-center justify-center ring-8 ring-white ${
                          event.eventType === "status_change"
                            ? "bg-blue-500"
                            : event.eventType === "manual"
                            ? "bg-green-500"
                            : "bg-app-surface-muted0"
                        }`}
                      >
                        <Timeline className="w-4 h-4 text-white" />
                      </span>
                    </div>
                    <div className="flex min-w-0 flex-1 justify-between space-x-4 pt-1.5">
                      <div className="flex-1">
                        {event.eventType === "status_change" ? (
                          <>
                            <p className="text-sm font-medium text-app-text">Status Changed</p>
                            <p className="text-sm text-app-text-secondary">
                              From <span className="font-medium">{event.fromStatus}</span> to{" "}
                              <span className="font-medium">{event.toStatus}</span>
                            </p>
                          </>
                        ) : (
                          <div className="text-sm font-medium text-app-text">
                            {(event.changes || []).map((change, index) => (
                              <p key={change}>
                                {(event.changes || []).length > 1
                                  ? `${index + 1}. ${change}`
                                  : change}
                              </p>
                            ))}
                          </div>
                        )}
                        <p className="text-xs text-app-text-muted mt-1">
                          by {event.changedBy || event.createdBy || "System"}
                        </p>
                      </div>
                      <div className="whitespace-nowrap text-right text-sm text-app-text-secondary">
                        {formatDisplayDateTime(event?.changeDate)}
                      </div>
                    </div>
                  </div>
                </div>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default TimelineTab;
